function apiBase(): string {
  return (
    process.env.REACT_APP_API_URL ||
    process.env.VITE_API_URL ||
    (typeof window !== 'undefined' ? window.location.origin : 'https://api.visime.com')
  );
}

function encodeAssetPath(name: string): string {
  return name
    .split('/')
    .map((part) => encodeURIComponent(part))
    .join('/');
}

export function getBusinessVideoUrl(video?: string): string | null {
  if (!video?.trim()) return null;
  if (/^https?:\/\//i.test(video)) return video;
  return `${apiBase()}/assets/video/site/clients/videos/${encodeAssetPath(video.trim())}`;
}

export function getSocialIconUrl(icon?: string): string | null {
  if (!icon?.trim()) return null;
  if (/^https?:\/\//i.test(icon)) return icon;
  return `${apiBase()}/assets/socialicons/${encodeAssetPath(icon.trim())}`;
}
